/* @flow */

import React from 'react';
import { CardProgress } from '../components/';
import { compose, withHandlers } from 'recompose';
import _ from 'lodash';
import { connect } from 'react-redux';
import actions from '../../actions';
import { PdfData } from '../../pdfer/Pdfable';
import LoadingStatus from './LoadingStatus';

import Translations from '../hocs/TranslationsHelper'; 
import CollapseGroupContainer, { CollapseGroupContainer2 } from './CollapseGroupContainer';
const getCardProgressContainerData = ({ achievementCards, achievementCardScores }) => {
  const data = _.map(achievementCards, (card) => {
    const achievementCardScore = _.find(achievementCardScores, {
      achievement_card_id: card.id
    }) || { score: 0 };

    return {
      id: card.id,
      title: card.name,
      excerpt: card.excerpt,
      description: card.description,
      value: parseInt(achievementCardScore.score, 10),
      tags: card.education_standards.map(({slug})=>slug),
      standards: card.education_standards
    };
  });

  return _.sortBy(data, [(o)=>(-o.value)] );

  //return data;
};

const getChallengeCardProgressContainerData = ({challenges, achievementCards, achievementCardScores }) => {

  const acmap = {};

  console.log("achievement cards: ", achievementCards);
  for(let ac of achievementCards){
    acmap[ac.id] = ac;
    ac.children = [];
  }
  
  for(let ac of achievementCards){
    if(ac.parent_id && ac.parent_id in acmap){
      acmap[ac.parent_id].children.push(ac);
    }
  }

  function query_tree(ac,out, level=0){
    ac.level = level;
    out.push(ac);
    for(let c of ac.children)
      query_tree(c, out, level + 1);
  }

  let data = [];
  for(let chall of challenges){
    if(chall.general_achievement_card_id in acmap){
      let acl = [];
      query_tree(acmap[chall.general_achievement_card_id], acl);

      let acs= [];

      for(let ac of acl){ 
        const achievementCardScore = _.find(achievementCardScores, {
          achievement_card_id: ac.id
        }) || { score: 0 };

        acs.push( {
          id: ac.id,
          level: ac.level,
          title: ac.name,
          excerpt: ac.excerpt,
          description: ac.description,
          value: parseInt(achievementCardScore.score, 10),
          tags: ac.education_standards.map(({slug})=>slug),
          standards: ac.education_standards
        });
      }
      data.push({
        challenge: chall,
        achievementCards: _.sortBy(acs, [(ac)=>( ac.level*1000 -ac.value)] )
      });
    }else{
      console.log("gac not in ac map", chall.general_achievement_card_id, acmap);
    }
  }
  return _.sortBy(data, [(o)=>(-o.achievementCards[0].value)] );

  //return data;
};



const CardProgressContainer = ({translations, challenges, achievementCards, achievementCardScores, onClick }: Props) => {
  //const data = getCardProgressContainerData({ achievementCards, achievementCardScores });
  const data =  getChallengeCardProgressContainerData({challenges, achievementCards, achievementCardScores });
  return (
    <div >
      <LoadingStatus request={["CHALLENGES", "ACHIEVEMENT_CARDS"]}/> 
      

      { data.map(({challenge, achievementCards} ) => 
        
          <CollapseGroupContainer2
            className="level-collapse"
            title={challenge.name || translations.t(challenge.slug)}
            id={challenge.id}
            key={challenge.id}
            icon="icon_level"
            count={achievementCards.length}
            onHeaderClick={()=>{}}
            onEditButtonClick={()=>{}}
            hideButtons
            lazy={true}
            all={false}
            expandedByDefault={achievementCards[0].value}
          >
            <br/>
            <div className="container-card-progress">
            {
              achievementCards.map(
                (props,key)=> 
                    <CardProgress key={key} {...props} onClick={onClick} />
              )
            }

            </div>
          </CollapseGroupContainer2>
      
      
      ) }
    </div>
  );
};

export const ContainerHandlers = {
  onClick: ({ dispatch }) => ({ title, html }) => {
    dispatch(actions.showHtmlContentModal({ title, html }));
  }
};

const ContainerComposed = Translations(compose(
  withHandlers(ContainerHandlers)
)(CardProgressContainer));

const mapDispatchToProps = (dispatch) => ({ dispatch });

const ContainerConnected = connect(
  null,
  mapDispatchToProps
)(ContainerComposed);

export default ContainerConnected;



export const CardProgressContainerPdf = Translations( ({ id,challenges,  achievementCards, achievementCardScores ,translations }: Props) => {
  
  const data =  getChallengeCardProgressContainerData({challenges, achievementCards, achievementCardScores });
  return (
    <div > 
      

      { data.map(({challenge, achievementCards} ) => 
      <PdfData key={challenge.id} path={"challlenge-prog-"+challenge.id } pdf={{newpage:true}}>
          <CollapseGroupContainer2
            className="level-collapse"
            title={challenge.name || translations.t(challenge.slug)}
            id={challenge.id}
            key={challenge.id}
            icon="icon_level"
            count={achievementCards.length}
            onHeaderClick={()=>{}}
            onEditButtonClick={()=>{}}
            hideButtons
            lazy={true}
            all={true}
          >
            <br/>
            <div className="container-card-progress">
            {
              achievementCards.map(
                (props,key)=> 
                    <CardProgress key={key} {...props}  />
              )
            }

            </div>
          </CollapseGroupContainer2>
      
        </PdfData>
      ) }
    </div>
  );
  
  
  // const data = getCardProgressContainerData({ achievementCards, achievementCardScores });
  // var cards = data.map((props, key) => <CardProgress key={key} {...props}  />);
  // var maxs =  16;
  // var splits = [];
  // var i=0;
  // while(i < cards.length){
  //   var n = Math.min(cards.length, i + maxs) -i; 

  //   splits.push(
  //     <PdfData key={splits.length} path={"card-prog-"+id+"-"+splits.length} pdf={{newpage:true}}>
        
  //       <h5 className="mt-5 mb-4">
  //           {translations.t('intelligence_screen_achievements_label')} {' '} 
  //       </h5>
  //     <div className="container-card-progress">{cards.slice(i, i+n)}</div>
  //   </PdfData>);

  //   i+=n;

  // }// className="container-card-progress"
  // return (
  //   <div>
  //     {splits }
  //   </div>
  // ); // data.map((props, key) => <CardProgress key={key} {...props} onClick={onClick} />) }
}); 